import gql from "graphql-tag";
import { VALUE_LIST_FRAGMENT } from "./valuelist-gql";
import { DIGITAL_ADDRESS_FRAGMENT } from "./contact-gql";
/*export const SEARCH_INDIVIDUALS = gql`
query SearchIndividuals($input:SearchIndividualInput!){
    searchIndividuals(input:$input){
      positionAssignmentId
      individualId
      individualFullName
      firstName
      lastName
      honorificTitle
      email
      positionName
      assignmentType
    }
  }
`;*/

export const GET_INDIVIDUAL_DETAILS =  gql`
    ${VALUE_LIST_FRAGMENT}
    ${DIGITAL_ADDRESS_FRAGMENT}
    query IndividualAssignment($positionAssignmentId: ID!,$individualId: ID!) {
      individualAssignment(positionAssignmentId: $positionAssignmentId,individualId:$individualId) {
          positionAssignmentId
          positionId
          positionName
          individualId
          firstName
          middleName
          lastName
          honorificTitle
          individualFullName
          email
          assignmentType
          indStatus
          indStatusReason {
            ...valueListFragment
          }
          restricted
          relType {
            ...valueListFragment
          }
          startDate
          acting
          gender {
            ...valueListFragment
          }
          honorific {
            ...valueListFragment
          }
          digitalAddresses {
            ...digitalAddressFragment
          }
          x509
        }
    }
`;

export const GET_INDIVIDUAL =  gql`
    ${DIGITAL_ADDRESS_FRAGMENT}
    ${VALUE_LIST_FRAGMENT}
    query Individual($individualId: ID!) {
        individual(individualId: $individualId) {
            individualId
            firstName
            middleName
            lastName
            individualFullName
            email
            x509
            acting
            restricted
            gender {
              ...valueListFragment
            }
            honorificTitle {
              ...valueListFragment
            }
            digitalAddresses {
                ...digitalAddressFragment
            }
        }
    }
`;

const SEARCH_INDIVIDUALS_FOR_NEW_FIELDS = `
      individuals{
        individualId
        fullName
        primaryEmail
        emails{
          emailAddressTxt
          presentationSeq
          assignType{
            id
            code
            label
          }
        }
        restricted
        active
        assignments{
          assignmentId
          positionId
          individualId
          fullPositionName
          relationshipType
          isRole
          isActive
        }
      }`;

export const SEARCH_INDIVIDUALS_FOR_NEW_ASSIGNMENT = gql`
query SearchIndividualsForNewAssignment($input:SearchIndividualsForNewInput!,$isActive:Boolean){
    searchIndividualsForNewAssignment(input:$input,isActive:$isActive){
      ${SEARCH_INDIVIDUALS_FOR_NEW_FIELDS}
    }
  }
`;

export const SEARCH_INDIVIDUALS_FOR_NEW_USER = gql`
query SearchIndividualsForNewUser($input:SearchIndividualsForNewInput!,$isActive:Boolean,$individualId:ID!){
    searchIndividualsForNewUser(input:$input,isActive:$isActive,individualId:$individualId){
      ${SEARCH_INDIVIDUALS_FOR_NEW_FIELDS}
    }
  }
`;

export const SEARCH__POSITION_INDIVIDUALS = gql`
query SearchPositionIndividuals($input:SearchPositionIndividualsInput!){
    searchPositionIndividuals(input:$input){
       id
       relId
       relTypeId
       relTypeCode
       relationshipType
       positionId
       positionTitle
       positionFullName
       individualId
       individualFullName
       firstName
       middleName
       lastName
       organizationId
       organizationName
  }
}
`;

export const CREATE_INDIVIDUAL = gql`
    mutation CreateIndividual($input:IndividualInput!){
        createIndividual(input:$input){
            individualId
            individualFullName
            email
        }
    }
`;

export const IS_EMAIL_EXISTS = gql`
query IsIndividualEmailExists($email:String){
    isIndividualEmailExists(email:$email)
  }
`;

export const IS_INDIVIDUAL_NAME_EXISTS = gql `
  query IsIndividualNameExists($firstName:String!,$lastName:String!){
    isIndividualNameExists(firstName:$firstName,lastName:$lastName)
  }`;

export const ASSIGN_INDIVIDUAL = gql `
  mutation AssignIndividual($positionId:ID!,$action:Action!, $input:AssignIndividualInput!){
    assignIndividual(positionId:$positionId,action:$action, input:$input){
      action
      success
      code
      message
    }
  }`;

  export const ASSIGN_MEMBERSHIP = gql `
  mutation AssignMembership($input:AssignMembershipInput!){
    assignMembership(input:$input){
      action
      success
      code
      message
    }
  }`;



export const INDIVIDUAL_ACTING_LINK_ASSIGNMENT = gql `
  query IndividualActingLinkAssignment($individualId:ID) {
    individualActingLinkAssignment(individualId:$individualId){
      assignmentId
      positionId
      positionTitle
      individualId
      relationshipType
      relatedOrganization
      relatedOrganizationId
      isScope
    }
}`;

export const IS_INDIVIDUAL_IN_SCOPE = gql `
    query IsIndividualInScope($individualId: ID!) {
      isIndividualInScope(individualId: $individualId)
    }
`;

export const INDIVIDUAL_ASSIGNMENTS = gql `
  query IndividualAssignments($individualId:ID!) {
    individualAssignments(individualId:$individualId){
      assignmentId
      positionId
      positionTitle
      fullPositionName
      individualId
      relationshipType
      relatedOrganization
      isScope
      isRole
      acting
      isActive
      deactivationReason
    }
}`;

export const IS_INDIVIDUAL_EDITABLE = gql `
    query IsIndividualEditable($individualId: ID!) {
      isIndividualEditable(individualId: $individualId)
    }
`;

export const UPDATE_INDIVIDUAL = gql`
    mutation UpdateIndividual($individualId:ID! ,$input:IndividualInput!){
        updateIndividual(individualId:$individualId, input:$input){
            individualId
        }
    }
`;

export const IS_INDIVIDUAL_READONLY = gql `
    query IsIndividualReadonly($individualId: ID!) {
      isIndividualReadonly(individualId: $individualId)
    }
`;

export const SEARCH_INDIVIDUAL = gql`
query SearchIndividual($input: SearchIndividualInput!) {
  searchIndividual(input: $input) {
    individuals{
      assignmentId
      individualId
      fullName
      positionId
      positionRole
      email
      title
      restricted
      role
      assignment
      active
    }
    message
  }
}
`;

export const SEARCH_POSITION_BASED_ASSIGNMENT = gql`
query searchPositionBasedIndividualAssignments($individualId:ID!) {
  searchPositionBasedIndividualAssignments(individualId: $individualId) {
   assignmentId
      positionId
      fullPositionName
      individualId
      relationshipType
      relatedOrganization
      isScope
      isRole
      acting
 }
}
`;
